var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 2.76398H5C3.75736 2.76398 2.75 3.77134 2.75 5.01398V20.764C2.75 22.0066 3.75736 23.014 5 23.014H16.25C17.4926 23.014 18.5 22.0066 18.5 20.764V5.01398C18.5 3.77134 17.4926 2.76398 16.25 2.76398Z",
    stroke: "#08387C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41 2.76398H29.75C28.5074 2.76398 27.5 3.77134 27.5 5.01398V11.764C27.5 13.0066 28.5074 14.014 29.75 14.014H41C42.2426 14.014 43.25 13.0066 43.25 11.764V5.01398C43.25 3.77134 42.2426 2.76398 41 2.76398Z",
    stroke: "#08387C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41 23.014H29.75C28.5074 23.014 27.5 24.0213 27.5 25.264V41.014C27.5 42.2566 28.5074 43.264 29.75 43.264H41C42.2426 43.264 43.25 42.2566 43.25 41.014V25.264C43.25 24.0213 42.2426 23.014 41 23.014Z",
    stroke: "#08387C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 32.014H5C3.75736 32.014 2.75 33.0213 2.75 34.264V41.014C2.75 42.2566 3.75736 43.264 5 43.264H16.25C17.4926 43.264 18.5 42.2566 18.5 41.014V34.264C18.5 33.0213 17.4926 32.014 16.25 32.014Z",
    stroke: "#08387C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDash);
export default __webpack_public_path__ + "static/media/dash.6564662110e2ba1cc22af8d824dab90b.svg";
export { ForwardRef as ReactComponent };